// src/components/news/NewsSourceCard.js - News source card component
const NewsSourceCard = ({ source, onEdit, onFetch, onToggle }) => {
  const getStatusBadge = (isActive) => {
    return isActive ? (
      <span className="px-2 py-1 text-xs font-medium bg-green-100 dark:bg-green-900/20 text-green-800 dark:text-green-400 rounded">
        Active
      </span>
    ) : (
      <span className="px-2 py-1 text-xs font-medium bg-gray-100 dark:bg-gray-900/20 text-gray-800 dark:text-gray-400 rounded">
        Inactive
      </span>
    );
  };

  return (
    <div className="p-4 bg-white dark:bg-shayek-dark-100 rounded-lg shadow border border-gray-200 dark:border-shayek-dark-200 hover:shadow-md transition-all">
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-shayek-dark-900 mb-1">{source.name}</h3>
          <p className="text-sm text-gray-600 dark:text-shayek-dark-600 mb-2">{source.url}</p>
          {source.rss_feed_url && (
            <p className="text-xs text-gray-500 dark:text-shayek-dark-500 truncate mb-2">{source.rss_feed_url}</p>
          )}
        </div>
        {getStatusBadge(source.is_active)}
      </div>

      <div className="flex flex-wrap gap-2 mb-3">
        {source.country && (
          <span className="px-2 py-1 text-xs bg-shayek-primary/10 dark:bg-shayek-primary/20 text-shayek-primary dark:text-shayek-red-light rounded">
            🌍 {source.country}
          </span>
        )}
        {source.language && (
          <span className="px-2 py-1 text-xs bg-purple-100 dark:bg-purple-900/20 text-purple-800 dark:text-purple-400 rounded">
            {source.language.toUpperCase()}
          </span>
        )}
        <span className="px-2 py-1 text-xs bg-gray-100 dark:bg-gray-900/20 text-gray-800 dark:text-gray-400 rounded">
          {source.source_type || 'rss'}
        </span>
      </div>

      {source.last_fetched_at && (
        <p className="text-xs text-gray-500 dark:text-shayek-dark-500 mb-3">
          Last fetched: {new Date(source.last_fetched_at).toLocaleString()}
        </p>
      )}

      <div className="flex gap-2">
        <button
          onClick={() => onEdit(source)}
          className="flex-1 px-3 py-2 text-sm text-gray-700 dark:text-shayek-dark-700 bg-gray-100 dark:bg-shayek-dark-50 rounded-lg hover:bg-gray-200 dark:hover:bg-shayek-dark-100 transition-colors border border-shayek-light-300 dark:border-shayek-dark-200"
        >
          Edit
        </button>
        {source.rss_feed_url && (
          <button
            onClick={() => onFetch(source.id)}
            className="flex-1 px-3 py-2 text-sm text-white bg-shayek-primary dark:bg-shayek-primary-600 rounded-lg hover:bg-shayek-primary-600 dark:hover:bg-shayek-red-light transition-colors shadow-shayek"
          >
            Fetch
          </button>
        )}
        <button
          onClick={() => onToggle(source.id, !source.is_active)}
          className={`px-3 py-2 text-sm rounded-lg transition-colors ${
            source.is_active
              ? 'text-red-700 dark:text-red-400 bg-red-100 dark:bg-red-900/20 hover:bg-red-200 dark:hover:bg-red-900/30'
              : 'text-green-700 dark:text-green-400 bg-green-100 dark:bg-green-900/20 hover:bg-green-200 dark:hover:bg-green-900/30'
          }`}
        >
          {source.is_active ? 'Deactivate' : 'Activate'}
        </button>
      </div>
    </div>
  );
};

export default NewsSourceCard;

